import React from 'react';
import { getContractFilePDF } from '../../utils';
import { SvgPdfIcon } from '../svg';
import { getOlderDeclarationReportPDF } from "../../utils";
import moment from 'moment';

class ContractFilesModal extends React.Component {

    constructor(props) {
        super(props)
        this.state = {}
    }

    getAppropriatePDF(item, contractId, e) {
        if (item.Type === 'File') {
            getContractFilePDF(contractId, item.RecId, `${item.Name}.pdf`, `#contractfile-${item.RecId}`);
        } else if (item.Type === 'Declaration') {
            getOlderDeclarationReportPDF(item.Id, contractId, item.RecId);
        } else {
            console.log("Error - Filetype not defined")
        }

    }

    getOlderDeclarations(declarations, contractId) {
        let declarationList = []
        if (declarations.declarationsByContractNumber && !declarations.isFetching) {
            Object.entries(declarations.declarationsByContractNumber).filter(([key, value]) => {
                Object.entries(value).filter(([k, val]) => {
                    if (k.includes(contractId)) {
                        val.map((v) => {
                            let item = {
                                Name: (v.Description ? v.Description : "Yfirlit"),
                                RecId: v.RecId,
                                Date: v.TransDate,
                                Type: 'Declaration',
                                Id: v.CustAccount
                            }
                            declarationList.push(item)
                        })
                    }
                })
                return value

            })
        }
        return declarationList;
    }



    getFiles(files, contractId) {
        let fileList = []
        files.map(cf => {
            let item = {
                Name: cf.Name,
                RecId: cf.RecId,
                Date: cf.CreatedDate,
                Type: 'File',
                Id: contractId
            }
            fileList.push(item)
        })
        return fileList
    }

    sortByDates(a, b) {
        let ad = moment(a.Date, "DD.MM.YYYY").toDate()
        let bd = moment(b.Date, "DD.MM.YYYY").toDate()
        return bd - ad;
    }

    render() {
        let { files, contractId, customerId, olderDeclarations } = this.props
        let data = this.getOlderDeclarations(olderDeclarations, contractId)
        
        if (files && files.length) {
            data.push(...this.getFiles(files, contractId))
        }
        let sortedList = data.sort(this.sortByDates)

        return (
            <div className="modal cfm" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel"
                aria-hidden="true" id={this.props.modalId}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <img src={window.images.logo} />
                            <button type="button" className="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                        </div>
                        <div className="modal-body">
                            {sortedList.length > 0 ?
                                <>
                                    <div className="row xs-pt-20">
                                        <div className="col-6 xs-mb-15">
                                            <strong>Nafn</strong>
                                        </div>
                                        <div className="col-6 xs-mb-15 text-right">
                                            <strong>Dagsetning</strong>
                                        </div>
                                    </div>
                                    {sortedList.map((d, key) => {
                                        return (
                                            <div key={key} className="row">
                                                <div className="col-6 xs-mb-15">
                                                    <a role="button" onClick={this.getAppropriatePDF.bind(this, d, contractId)}>
                                                        <SvgPdfIcon /> {d.Name}
                                                        <i id={`contractfile-${d.RecId}`} style={{ display: 'none' }} className="xs-ml-10 fa fa-spin fa-sync-alt" />
                                                    </a>
                                                </div>
                                                <div className="col-6 xs-mb-15 text-right">
                                                    <div> {d.Date} </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </>
                                :
                                <>
                                    <div className="row">
                                        <div className="col-12 xs-pt-20 xs-pb-20 text-center">
                                            Engin skjöl hafa verið birt fyrir þennan samning.
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

ContractFilesModal.defaultProps = {}
export default ContractFilesModal;